// ids/fast.ts
const B64URL = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789-_";
// Reused buffers (safe in single-threaded Workers / browsers)
const _buf2 = new Uint8Array(2);
const _buf4 = new Uint8Array(4);
const _buf8 = new Uint8Array(8);
const _buf16 = new Uint8Array(16);
// 2 bytes → 3 chars (16 bits)
export function id3() {
    crypto.getRandomValues(_buf2);
    const n = (_buf2[0] << 8) | _buf2[1];
    return (B64URL[(n >>> 10) & 63] +
        B64URL[(n >>> 4) & 63] +
        B64URL[(n << 2) & 63]);
}
// 4 bytes → 6 chars (32 bits)
export function id6() {
    crypto.getRandomValues(_buf4);
    const n = (_buf4[0] << 24) |
        (_buf4[1] << 16) |
        (_buf4[2] << 8) |
        _buf4[3];
    return (B64URL[(n >>> 26) & 63] +
        B64URL[(n >>> 20) & 63] +
        B64URL[(n >>> 14) & 63] +
        B64URL[(n >>> 8) & 63] +
        B64URL[(n >>> 2) & 63] +
        B64URL[(n << 4) & 63]);
}
// 8 bytes → 11 chars (64 bits)
export function id11() {
    crypto.getRandomValues(_buf8);
    let out = "";
    let n = (_buf8[0] << 16) |
        (_buf8[1] << 8) |
        _buf8[2];
    out +=
        B64URL[(n >>> 18) & 63] +
            B64URL[(n >>> 12) & 63] +
            B64URL[(n >>> 6) & 63] +
            B64URL[n & 63];
    n =
        (_buf8[3] << 16) |
            (_buf8[4] << 8) |
            _buf8[5];
    out +=
        B64URL[(n >>> 18) & 63] +
            B64URL[(n >>> 12) & 63] +
            B64URL[(n >>> 6) & 63] +
            B64URL[n & 63];
    n =
        (_buf8[6] << 16) |
            (_buf8[7] << 8);
    out +=
        B64URL[(n >>> 18) & 63] +
            B64URL[(n >>> 12) & 63] +
            B64URL[(n >>> 6) & 63];
    return out;
}
// 16 bytes → 22 chars (128 bits, UUID replacement)
export function id22() {
    crypto.getRandomValues(_buf16);
    let out = "";
    for (let i = 0; i < 15; i += 3) {
        const n = (_buf16[i] << 16) |
            (_buf16[i + 1] << 8) |
            _buf16[i + 2];
        out +=
            B64URL[(n >>> 18) & 63] +
                B64URL[(n >>> 12) & 63] +
                B64URL[(n >>> 6) & 63] +
                B64URL[n & 63];
    }
    const n = _buf16[15] << 16;
    out +=
        B64URL[(n >>> 18) & 63] +
            B64URL[(n >>> 12) & 63];
    return out;
}
